import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';
import hasValidationErrors from '../../components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob, IJobMeta } from '../../utils/BackgroundJobs';
import BoxLabelInstructions from '../../graphql/entities/sales/BoxLabelInstructions';
import { getMutationProps, getRangeMutationProps } from './DocumentAction';

const onComplete = (state: any, props: any, job: any): void => {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Box Label',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
};

export const generate = (state: any, props: any, variables: any, returnUrl: any): void => {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    BoxLabelInstructions.generate,
    getMutationProps(state, props, variables, 'dispatchInstruction'),
    props,
    returnUrl,
    'Generate Box Labels',
    (job: IJobMeta) => onComplete(state, props, job)
  );
};

export const generateRange = (state: any, props: any, variables: any, returnUrl: any): void => {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    BoxLabelInstructions.generateRange,
    getRangeMutationProps(state, props, variables, 'dispatchInstructions', BoxLabelInstructions.workspaceUrl),
    props,
    returnUrl,
    'Generate Box Labels',
    (job: IJobMeta): void => onComplete(state, props, job),
    (job: IJobMeta): void => onDocumentPrintFailed(state, props, job)
  );
};
